import { Injectable } from '@angular/core';

const SESSION_ID_KEY = 'x-session-id';

function generateUuid(): string {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID();
  }
  // Fallback RFC 4122 v4 (browsers/entornos sin crypto.randomUUID)
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.floor(Math.random() * 16);
    const v = c === 'x' ? r : (r % 4) + 8;
    return v.toString(16);
  });
}

/**
 * Identificador estable por sesion de browser (sessionStorage): a diferencia
 * del traceability-id (uuid nuevo POR request), permite agrupar en Loki todo
 * lo que hizo un usuario en una sesion.
 */
@Injectable({ providedIn: 'root' })
export class SessionIdService {
  #sessionId?: string;

  getSessionId(): string {
    if (this.#sessionId) {
      return this.#sessionId;
    }
    let sessionId: string | null = null;
    try {
      sessionId = sessionStorage.getItem(SESSION_ID_KEY);
      if (!sessionId) {
        sessionId = generateUuid();
        sessionStorage.setItem(SESSION_ID_KEY, sessionId);
      }
    } catch {
      // sessionStorage no disponible (SSR, privacidad): id efimero en memoria
      sessionId = generateUuid();
    }
    this.#sessionId = sessionId;
    return sessionId;
  }
}
